<template>
  <v-snackbar ref="notice" v-model="show" :color="color" v-on:keyup.escape="close">
    {{ message }}
    <v-btn text @click="show = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      message: '',
      color: ''
    }
  },

  created () {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'showMessage') {
        this.message = state.notifier.content
        this.color = state.notifier.color
        this.show = true
      }
    })
  },
  methods: {
      close: () => this.show = false
  }
}
</script>
